import type { ReactNode } from 'react'

/** Bordered card shell with a titled header — the action log's outer chrome. */
export const ActionLogCard = ({
  title,
  children,
}: {
  title: string
  children: ReactNode
}) => (
  <div className="mt-4 overflow-hidden rounded-lg border border-gray-200 bg-white">
    <div className="border-b border-gray-200 px-5 py-4">
      <span className="text-lg font-semibold text-primary">{title}</span>
    </div>
    <div className="px-5 py-5">{children}</div>
  </div>
)
